export default __webpack_public_path__ + "static/media/logoOnb.83cbfa0e.png";